import React from "react";
import { AlertTriangle, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/site";

export const EmergencyBanner = () => {
  return (
    <a
      href={`tel:${PHONE_TEL}`}
      data-testid="emergency-banner"
      className="block bg-[#C8102E] hover:bg-[#9E0C24] transition-colors"
    >
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-center gap-3 text-white text-center">
        <AlertTriangle className="h-5 w-5 shrink-0" strokeWidth={2.5} />
        <span className="font-heading font-bold uppercase tracking-[0.15em] text-sm sm:text-base">
          Emergency Restoration — Same Day / 24-7 · Call {PHONE_DISPLAY}
        </span>
        <Phone className="h-5 w-5 shrink-0 hidden sm:block" strokeWidth={2.5} />
      </div>
    </a>
  );
};
